(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2145],{

/***/ 22636:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customizing/print",
      function () {
        return __webpack_require__(41401);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 56516:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C9": function() { return /* binding */ FAQContent; },
/* harmony export */   "SC": function() { return /* binding */ TableRow; },
/* harmony export */   "UZ": function() { return /* binding */ FAQTop; },
/* harmony export */   "l5": function() { return /* binding */ FAQTitle; },
/* harmony export */   "y6": function() { return /* binding */ TableWrapper; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19521);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  border-top: 2px solid black;\n  overflow-x: hidden;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  height: auto;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  border-bottom: 1px solid #ececec;\n  color: black;\n  cursor: pointer;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: ",
        ";\n  color: ",
        ";\n  padding: 0 2rem;\n  -webkit-transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);\n  transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);\n  :hover {\n    background-color: #3bb77e;\n    color: white;\n  }\n  & i {\n    font-size: 1.5rem;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  height: 5rem;\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  display: ",
        ";\n  border-top: 1px solid #ececec;\n  padding: 2rem 2rem;\n  font-weight: 300;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

var TableWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-2c6470e0-0"
})(_templateObject());
var TableRow = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-2c6470e0-1"
})(_templateObject1());
var FAQTop = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-2c6470e0-2"
})(_templateObject2(), function(props) {
    return props.isActive ? "#3bb77e" : "#fff";
}, function(props) {
    return props.isActive ? "#fff" : "black";
});
var FAQTitle = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-2c6470e0-3"
})(_templateObject3());
var FAQContent = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-2c6470e0-4"
})(_templateObject4(), function(props) {
    return props.isActive ? "block" : "none";
});


/***/ }),

/***/ 99076:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AA": function() { return /* binding */ strengthArr; },
/* harmony export */   "_z": function() { return /* binding */ SizeData; },
/* harmony export */   "vW": function() { return /* binding */ strengthSlideArr; }
/* harmony export */ });
var strengthArr = [
    {
        img: "https://file.caretbio.com/caretbio/d3f17881d53c62b768c375f1861a37e0.png",
        desc: [
            "\uCD5C\uC18C 100\uC7A5\uBD80\uD130 \uC778\uC1C4 \uAC00\uB2A5! \uC18C\uADDC\uBAA8 \uBAA8\uC784, \uAD7F\uC988\uC6A9\uC73C\uB85C \uC88B\uC544\uC694"
        ]
    },
    {
        img: "https://file.caretbio.com/caretbio/5883bfada5b43ef3c3c598834078fdb9.png",
        desc: [
            "\uCD5C\uC18C \uBE44\uC6A9\uC73C\uB85C \uCD5C\uB300 \uB9C8\uCF00\uD305 \uD6A8\uACFC\uB97C",
            "\uBCFC \uC218 \uC788\uC2B5\uB2C8\uB2E4"
        ]
    },
    {
        img: "https://file.caretbio.com/caretbio/4625024a198591171f84a2ee33faf84d.png",
        desc: [
            "\uC778\uC1C4 \uAE30\uAC04\uC740 \uC77C\uC8FC\uC77C!",
            "\uBE60\uB974\uAC8C \uC791\uC5C5\uD558\uC5EC \uBCF4\uB0B4\uB4DC\uB824\uC694"
        ]
    }, 
];
var strengthSlideArr = [
    {
        img: "https://file.caretbio.com/caretbio/c9f2c279f7b9fd0d8ba691e98a7ee08a.png",
        title: "\uB113\uC740 \uC778\uC1C4\uC601\uC5ED",
        desc: "\uCE5C\uD658\uACBD \uC18C\uC7AC \uBD09\uD22C\uC5D0 \uBE0C\uB79C\uB4DC \uB85C\uACE0\uB97C \uB123\uC5B4 \uBE0C\uB79C\uB4DC \uAC00\uCE58\uB97C \uC62C\uB824\uC8FC\uC138\uC694"
    },
    {
        img: "https://file.caretbio.com/caretbio/488787e1a0ee5fd0d844199b8a156c8f.png",
        title: "\uC720\uB7FD\uC0B0 \uC789\uD06C \uC0AC\uC6A9",
        desc: "\uC778\uC1C4 \uD488\uC9C8 \uAE30\uC900\uC774 \uC5C4\uACA9\uD55C \uC720\uB7FD\uC0B0 \uC789\uD06C\uB97C \uC0AC\uC6A9\uD574\uC694"
    },
    {
        img: "https://file.caretbio.com/caretbio/862aad3dcbdbe75508401667fdfdbcba.png",
        title: "\uB2E4\uC591\uD55C \uCEEC\uB7EC\uC640 \uC0AC\uC774\uC988",
        desc: "\uC778\uB514\uD551\uD06C, \uB124\uC628, \uBE14\uB799, \uD06C\uB9BC, \uBC18\uD22C\uBA85\uC18D\uBE44\uB2D0\uAE4C\uC9C0 \uC6A9\uB3C4\uC640 \uBD84\uC704\uAE30\uC5D0 \uB9DE\uAC8C \uC120\uD0DD\uD560 \uC218 \uC788\uC5B4\uC694"
    },
    {
        img: "https://file.caretbio.com/caretbio/621486502fe74265b2490993660a13dd.png",
        title: "\uCE5C\uD658\uACBD \uC18C\uC7AC",
        desc: "\uCE5C\uD658\uACBD \uC7AC\uC0DD \uD0DD\uBC30\uBD09\uD22C(EL606)\uC640 \uBC14\uC774\uC624\uB9E4\uC2A4 \uD0DD\uBC30\uBD09\uD22C(EL727)\uC5D0 \uC18C\uC911\uD55C \uC81C\uD488\uC744 \uB2F4\uC544 \uBCF4\uC138\uC694"
    }, 
];
var SizeData = {
    EL606택배봉투_인디핑크: [
        {
            title: "\uC18C size",
            size: "250mm x 350mm + 40mm",
            desc: "\uC587\uC740 \uC758\uB958, \uC18D\uC637, \uBAA8\uC790\uB97C \uD3EC\uC7A5\uD558\uAE30 \uC801\uD569\uD55C \uC0AC\uC774\uC988 \uC785\uB2C8\uB2E4.",
            imgs: [
                {
                    url: "/assets/imgs/print/info_size/EL606_\uC778\uB514\uD551\uD06C_\uC18C.jpg",
                    desc: ""
                }, 
            ]
        },
        {
            title: "\uC911 size",
            size: "320mm x 400mm + 40mm",
            desc: "\uC154\uCE20, \uB2C8\uD2B8, \uBC14\uC9C0\uB97C \uD3EC\uC7A5\uD558\uAE30 \uC801\uD569\uD55C \uC0AC\uC774\uC988 \uC785\uB2C8\uB2E4.",
            imgs: [
                {
                    url: "/assets/imgs/print/info_size/EL606_\uC778\uB514\uD551\uD06C_\uC911.jpg",
                    desc: ""
                }, 
            ]
        },
        {
            title: "\uB300 size",
            size: "380mm x 470mm + 40mm",
            desc: "\uD6C4\uB4DC\uD2F0, \uB3C4\uD1B0\uD55C \uC758\uB958\uB97C \uD3EC\uC7A5\uD558\uAE30 \uC801\uD569\uD55C \uC0AC\uC774\uC988 \uC785\uB2C8\uB2E4.",
            imgs: [
                {
                    url: "/assets/imgs/print/info_size/EL606_\uC778\uB514\uD551\uD06C_\uB300.jpg",
                    desc: ""
                }, 
            ]
        }, 
    ],
    EL606택배봉투_네온: [
        {
            title: "\uD2B9\uB300 1\uD638 size",
            size: "450mm x 580mm + 40mm",
            desc: "\uC544\uC6B0\uD130 \uB450\uAEBC\uC6B4 \uD6C4\uB4DC\uD2F0\uB97C \uD3EC\uC7A5\uD558\uAE30 \uC801\uD569\uD55C \uC0AC\uC774\uC988 \uC785\uB2C8\uB2E4.",
            imgs: [
                {
                    url: "/assets/imgs/print/info_size/EL606_\uB124\uC628_\uD2B9\uB3001.jpg",
                    desc: ""
                }, 
            ]
        },
        {
            title: "\uD2B9\uB300 2\uD638 size",
            size: "550mm x 800mm + 40mm",
            desc: "\uACA8\uC6B8\uC6A9 \uC544\uC6B0\uD130\uB97C \uD3EC\uC7A5\uD558\uAE30 \uC801\uD569\uD55C \uC0AC\uC774\uC988 \uC785\uB2C8\uB2E4.",
            imgs: [
                {
                    url: "/assets/imgs/print/info_size/EL606_\uB124\uC628_\uD2B9\uB3002.jpg",
                    desc: ""
                }, 
            ]
        },
        {
            title: "\uD2B9\uB300 3\uD638 size",
            size: "700mm x 830mm + 40mm",
            desc: "\uC774\uBD88 \uD328\uB4DC\uB97C \uD3EC\uC7A5\uD558\uAE30 \uC801\uD569\uD55C \uC0AC\uC774\uC988 \uC785\uB2C8\uB2E4.",
            imgs: [
                {
                    url: "/assets/imgs/print/info_size/EL606_\uB124\uC628_\uD2B9\uB3003.jpg",
                    desc: ""
                }, 
            ]
        }, 
    ],
    EL727택배봉투_블랙: [
        {
            title: "\uC911 size",
            size: "320mm x 400mm + 40mm",
            desc: "\uC154\uCE20, \uB2C8\uD2B8, \uBC14\uC9C0\uB97C \uD3EC\uC7A5\uD558\uAE30 \uC801\uD569\uD55C \uC0AC\uC774\uC988 \uC785\uB2C8\uB2E4.",
            imgs: [
                {
                    url: "/assets/imgs/print/info_size/EL727_\uBE14\uB799_\uC911.jpg",
                    desc: ""
                }, 
            ]
        },
        {
            title: "\uB300 size",
            size: "380mm x 470mm + 40mm",
            desc: "\uD6C4\uB4DC\uD2F0, \uB3C4\uD1B0\uD55C \uC758\uB958\uB97C \uD3EC\uC7A5\uD558\uAE30 \uC801\uD569\uD55C \uC0AC\uC774\uC988 \uC785\uB2C8\uB2E4.",
            imgs: [
                {
                    url: "/assets/imgs/print/info_size/EL727_\uBE14\uB799_\uB300.jpg",
                    desc: ""
                }, 
            ]
        }, 
    ],
    EL727택배봉투_아이보리: [
        {
            title: "\uC18C size",
            size: "250mm x 350mm + 40mm",
            desc: "\uC587\uC740 \uC758\uB958, \uC18D\uC637, \uBAA8\uC790\uB97C \uD3EC\uC7A5\uD558\uAE30 \uC801\uD569\uD55C \uC0AC\uC774\uC988 \uC785\uB2C8\uB2E4.",
            imgs: [
                {
                    url: "/assets/imgs/print/info_size/EL727_\uD06C\uB9BC_\uC18C.jpg",
                    desc: ""
                }, 
            ]
        },
        {
            title: "\uC911 size",
            size: "320mm x 400mm + 40mm",
            desc: "\uC154\uCE20, \uB2C8\uD2B8, \uBC14\uC9C0\uB97C \uD3EC\uC7A5\uD558\uAE30 \uC801\uD569\uD55C \uC0AC\uC774\uC988 \uC785\uB2C8\uB2E4.",
            imgs: [
                {
                    url: "/assets/imgs/print/info_size/EL727_\uD06C\uB9BC_\uC911.jpg",
                    desc: ""
                }, 
            ]
        },
        {
            title: "\uB300 size",
            size: "380mm x 470mm + 40mm",
            desc: "\uD6C4\uB4DC\uD2F0, \uB3C4\uD1B0\uD55C \uC758\uB958\uB97C \uD3EC\uC7A5\uD558\uAE30 \uC801\uD569\uD55C \uC0AC\uC774\uC988 \uC785\uB2C8\uB2E4.",
            imgs: [
                {
                    url: "/assets/imgs/print/info_size/EL727_\uD06C\uB9BC_\uB300.jpg",
                    desc: ""
                }, 
            ]
        },
        {
            title: "\uD2B9\uB300 size",
            size: "450mm x 580mm + 40mm",
            desc: "\uC544\uC6B0\uD130 \uB450\uAEBC\uC6B4 \uD6C4\uB4DC\uD2F0\uB97C \uD3EC\uC7A5\uD558\uAE30 \uC801\uD569\uD55C \uC0AC\uC774\uC988 \uC785\uB2C8\uB2E4.",
            imgs: [
                {
                    url: "/assets/imgs/print/info_size/EL727_\uD06C\uB9BC_\uD2B9\uB300.jpg",
                    desc: ""
                }, 
            ]
        }, 
    ],
    EL727속비닐봉투_반투명: [
        {
            title: "\uBBF8\uB2C8 size",
            size: "110mm x 170mm + 40mm",
            desc: "\uCE74\uB4DC \uC545\uC138\uC0AC\uB9AC \uC0AC\uC9C4\uC744 \uD3EC\uC7A5\uD558\uAE30 \uC801\uD569\uD55C \uC0AC\uC774\uC988 \uC785\uB2C8\uB2E4.",
            imgs: [
                {
                    url: "/assets/imgs/print/info_size/EL727_\uBC18\uD22C\uBA85_\uBBF8\uB2C8.jpg",
                    desc: ""
                }, 
            ]
        },
        {
            title: "\uD2B9\uC18C size",
            size: "170mm x 250mm + 40mm",
            desc: "\uC218\uCCA9 \uD578\uB4DC\uD3F0\uCF00\uC774\uC2A4\uB97C \uD3EC\uC7A5\uD558\uAE30 \uC801\uD569\uD55C \uC0AC\uC774\uC988 \uC785\uB2C8\uB2E4.",
            imgs: [
                {
                    url: "/assets/imgs/print/info_size/EL727_\uBC18\uD22C\uBA85_\uD2B9\uC18C.jpg",
                    desc: ""
                }, 
            ]
        },
        {
            title: "\uC18C size",
            size: "250mm x 350mm + 40mm",
            desc: "\uC587\uC740 \uC758\uB958, \uC18D\uC637, \uBAA8\uC790\uB97C \uD3EC\uC7A5\uD558\uAE30 \uC801\uD569\uD55C \uC0AC\uC774\uC988 \uC785\uB2C8\uB2E4.",
            imgs: [
                {
                    url: "/assets/imgs/print/info_size/EL727_\uBC18\uD22C\uBA85_\uC18C.jpg",
                    desc: ""
                }, 
            ]
        },
        {
            title: "\uC911 size",
            size: "320mm x 400mm + 40mm",
            desc: "\uC154\uCE20, \uB2C8\uD2B8, \uBC14\uC9C0\uB97C \uD3EC\uC7A5\uD558\uAE30 \uC801\uD569\uD55C \uC0AC\uC774\uC988 \uC785\uB2C8\uB2E4.",
            imgs: [
                {
                    url: "/assets/imgs/print/info_size/EL727_\uBC18\uD22C\uBA85_\uC911.jpg",
                    desc: ""
                }, 
            ]
        },
        {
            title: "\uB300 size",
            size: "380mm x 470mm + 40mm",
            desc: "\uD6C4\uB4DC\uD2F0, \uB3C4\uD1B0\uD55C \uC758\uB958\uB97C \uD3EC\uC7A5\uD558\uAE30 \uC801\uD569\uD55C \uC0AC\uC774\uC988 \uC785\uB2C8\uB2E4.",
            imgs: [
                {
                    url: "/assets/imgs/print/info_size/EL727_\uBC18\uD22C\uBA85_\uB300.jpg",
                    desc: ""
                }, 
            ]
        }, 
    ]
};


/***/ }),

/***/ 41401:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ print; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/layout/Layout.js + 38 modules
var Layout = __webpack_require__(32511);
// EXTERNAL MODULE: ./components/customizing/print/Print.styles.js
var Print_styles = __webpack_require__(32252);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/customizing/print/PrintInquiryModal.js
var PrintInquiryModal = __webpack_require__(87607);
// EXTERNAL MODULE: ./common/alert.js
var common_alert = __webpack_require__(55150);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(64384);
// EXTERNAL MODULE: ./api/products.js
var products = __webpack_require__(81628);
// EXTERNAL MODULE: ./components/elements/inquiryCompleteModal.js
var inquiryCompleteModal = __webpack_require__(43774);
// EXTERNAL MODULE: ./redux/action/loading.js
var loading = __webpack_require__(19828);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(30719);
// EXTERNAL MODULE: ./components/customizing/print/Print.data.js
var Print_data = __webpack_require__(99076);
// EXTERNAL MODULE: ./components/filterList/FilterList.js + 3 modules
var filterList_FilterList = __webpack_require__(85830);
// EXTERNAL MODULE: ./components/customizing/print/printCart/PrintCart.js + 1 modules
var printCart_PrintCart = __webpack_require__(34077);
// EXTERNAL MODULE: ./hook/customizing/print/usePrintFaqQuery.js
var print_usePrintFaqQuery = __webpack_require__(39117);
// EXTERNAL MODULE: ./components/csboard/faq/faq-styles.js
var faq_styles = __webpack_require__(56516);
// EXTERNAL MODULE: ./hook/customizing/print/useTabStickyHandler.js
var print_useTabStickyHandler = __webpack_require__(15634);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./components/customizing/print/Print.presenter.js












var PrintPageUI = function(props) {
    var ref;
    var onClickInquiry = props.onClickInquiry, listRef = props.listRef, cartRef = props.cartRef, productList = props.productList, addPrintCart = props.addPrintCart, inCart = props.inCart, userInfo = props.userInfo, userCompany = props.userCompany, printCartItems = props.printCartItems, setPrintCartItems = props.setPrintCartItems;
    var observers = Array.from({
        length: 10
    }, function(_, index) {
        return useInView({
            threshold: 0.1
        });
    });
    var router = useRouter();
    var tabHeaderRef = useRef(null);
    var isSticky = useTabStickyHandler(tabHeaderRef).isSticky; // 탭 헤더 sticky 상태 관리
    var ref1 = useState(0), activeComponent = ref1[0], setActiveComponent = ref1[1];
    var ref2 = useState(0), activeTab = ref2[0], setActiveTab = ref2[1]; // 사이즈 탭
    var ref3 = useState(0), activeMainTab = ref3[0], setActiveMainTab = ref3[1]; // 메인 탭 (0: 재질, 1: 가이드 및 필수사항, 2: 견적 및 구매)
    var ref4 = useState(""), isActive = ref4[0], setIsActive = ref4[1]; //faq
    var ref5 = usePrintFaqQuery(router.isReady), faqList = ref5.data, isLoading = ref5.isLoading, error = ref5.error; //faq 리스트
    // 리스트로 이동시키기
    var moveToList = function() {
        window.scrollTo({
            behavior: "smooth",
            left: 0,
            top: listRef.current.offsetTop
        });
    };
    useEffect(function() {
        // URL 쿼리 파라미터에서 tab 값을 확인
        if (router.isReady && router.query.tab === "product") {
            // 상품 • 견적 탭 인덱스로 설정 (FAQ 유무에 따라 5 또는 6)
            var productTabIndex = faqList && faqList.length > 0 ? 6 : 5;
            onChangeMainTab(productTabIndex);
            // 상품 목록 위치로 스크롤 (필요한 경우)
            if (listRef.current) {
                setTimeout(function() {
                    window.scrollTo({
                        behavior: "smooth",
                        top: listRef.current.offsetTop
                    });
                }, 100);
            }
        }
    }, [
        router.isReady,
        router.query,
        faqList
    ]);
    useEffect(function() {
        var inViews = observers.map(function(el) {
            return el.inView;
        });
        if (!inViews.includes(true)) {
            if (activeComponent === 3 || activeComponent === 4) {
                setActiveComponent(4);
                return;
            }
            setActiveComponent(0);
            return;
        }
        inViews.forEach(function(el, i) {
            if (el === true) {
                if (i === 0) {
                    setActiveComponent(i);
                } else if (inViews[i - 1] === true) {
                    setActiveComponent(i - 1);
                } else {
                    setActiveComponent(i);
                }
            }
        });
    }, [
        observers
    ]);
    var shouldShowTabContent = function(tabIndex) {
        // FAQ 탭(5)인 경우
        if (tabIndex === 5) {
            return faqList && faqList.length > 0 && activeMainTab === 5;
        }
        // 상품 구매 탭인 경우
        if (tabIndex === 6) {
            // FAQ가 없으면 5번, 있으면 6번
            return (!faqList || faqList.length === 0) && activeMainTab === 5 || faqList && faqList.length > 0 && activeMainTab === 6;
        }
        // 다른 탭들
        return activeMainTab === tabIndex;
    };
    // 메인 탭 변경 함수
    var onChangeMainTab = function(tabIndex) {
        // 탭 상태 업데이트
        setActiveMainTab(tabIndex);
        // 페이지 상단으로 스크롤
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    var onClickOpenFAQ = function(i) {
        return function() {
            if (isActive !== i) setIsActive(i);
            if (isActive === i) setIsActive("");
        };
    };
    var tabs = faqList && faqList.length === 0 ? defaultTabs.filter(function(tab) {
        return tab.label !== "FAQ";
    }) : defaultTabs;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(P.TabContainer, {
                ref: tabHeaderRef,
                isSticky: isSticky,
                children: /*#__PURE__*/ _jsx(P.TabHeader, {
                    children: tabs.map(function(tab, index) {
                        return /*#__PURE__*/ _jsx(P.TabItem, {
                            active: activeMainTab === index,
                            onClick: function() {
                                return onChangeMainTab(index);
                            },
                            children: tab.label
                        }, index);
                    })
                })
            }),
            activeMainTab === 0 && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "container",
                        children: [
                            /*#__PURE__*/ _jsxs(P.NormalTitle, {
                                children: [
                                    /*#__PURE__*/ _jsx("strong", {
                                        children: "\uC18C\uB7C9\uC778\uC1C4"
                                    }),
                                    " \uC11C\uBE44\uC2A4 \uC18C\uAC1C"
                                ]
                            }),
                            /*#__PURE__*/ _jsx(P.StrengthWarpper, {
                                children: strengthArr.map(function(st, idx) {
                                    return /*#__PURE__*/ _jsxs(P.StrengthBox, {
                                        children: [
                                            /*#__PURE__*/ _jsx("img", {
                                                src: st.img,
                                                alt: st.img
                                            }),
                                            st.desc.map(function(el, i) {
                                                return /*#__PURE__*/ _jsx("p", {
                                                    children: el
                                                }, i);
                                            })
                                        ]
                                    }, idx);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(P.StrengthSliderWrapper, {
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "strengthSection",
                                children: /*#__PURE__*/ _jsxs(P.StrengthPC, {
                                    className: "container",
                                    children: [
                                        /*#__PURE__*/ _jsxs("h6", {
                                            children: [
                                                "\uCE7C\uB81B\uC2A4\uD1A0\uC5B4\uC758 ",
                                                /*#__PURE__*/ _jsx("strong", {
                                                    children: "\uC18C\uB7C9\uC778\uC1C4"
                                                }),
                                                "\uAC00 \uD2B9\uBCC4\uD55C \uC774\uC720!"
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "strengthGrid",
                                            children: strengthSlideArr.map(function(str, idx) {
                                                return /*#__PURE__*/ _jsxs("div", {
                                                    className: "content",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("img", {
                                                            src: str.img
                                                        }),
                                                        /*#__PURE__*/ _jsxs("div", {
                                                            className: "desc",
                                                            children: [
                                                                /*#__PURE__*/ _jsx("h6", {
                                                                    children: str.title
                                                                }),
                                                                /*#__PURE__*/ _jsx("span", {
                                                                    children: str.desc
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }, idx);
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "container swiperSection",
                                children: [
                                    /*#__PURE__*/ _jsx(Swiper, {
                                        navigation: {
                                            prevEl: ".custom_prev_i1",
                                            nextEl: ".custom_next_i1"
                                        },
                                        pagination: {
                                            clickable: true,
                                            el: ".swiper-pagination"
                                        },
                                        children: strengthSlideArr.map(function(str, idx) {
                                            return /*#__PURE__*/ _jsx(SwiperSlide, {
                                                children: /*#__PURE__*/ _jsxs(P.StrengthSlide, {
                                                    children: [
                                                        /*#__PURE__*/ _jsxs("h6", {
                                                            children: [
                                                                "\uCE7C\uB81B\uC2A4\uD1A0\uC5B4\uC758 ",
                                                                /*#__PURE__*/ _jsx("strong", {
                                                                    children: "\uC18C\uB7C9\uC778\uC1C4"
                                                                }),
                                                                "\uAC00 \uD2B9\uBCC4\uD55C \uC774\uC720!"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ _jsxs("div", {
                                                            className: "content",
                                                            children: [
                                                                /*#__PURE__*/ _jsx("img", {
                                                                    src: str.img
                                                                }),
                                                                /*#__PURE__*/ _jsxs("div", {
                                                                    className: "desc",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx("h6", {
                                                                            children: str.title
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("span", {
                                                                            children: str.desc
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }, idx);
                                        })
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "slider-arrow",
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "slider-btn slider-prev slick-arrow custom_prev_i1",
                                                children: /*#__PURE__*/ _jsx("i", {
                                                    className: "fi-rs-angle-left"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "slider-btn slider-next slick-arrow custom_next_i1",
                                                children: /*#__PURE__*/ _jsx("i", {
                                                    className: "fi-rs-angle-right"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "swiper-pagination"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            activeMainTab === 1 && /*#__PURE__*/ _jsx(_Fragment, {
                children: /*#__PURE__*/ _jsxs(P.DesignGuide, {
                    className: "container",
                    id: "guide",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "d-flex flex-column mb-50 pb-80 border-bottom",
                            children: [
                                /*#__PURE__*/ _jsxs(P.NormalTitle, {
                                    children: [
                                        /*#__PURE__*/ _jsx("strong", {
                                            children: "\uCE5C\uC808\uD55C \uAC00\uC774\uB4DC"
                                        }),
                                        "\uB85C \uC27D\uACE0, \uD3B8\uD558\uAC8C!"
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(P.TitleDesc, {
                                    children: [
                                        "\uC608\uC2DC \uC0AC\uC774\uC988(450mm x 580mm + 40mm)\uC640",
                                        " ",
                                        /*#__PURE__*/ _jsx("strong", {
                                            className: "",
                                            children: "\uB3D9\uC77C\uD55C \uADDC\uCE59"
                                        }),
                                        "\uC73C\uB85C",
                                        /*#__PURE__*/ _jsx("strong", {
                                            className: "ms-1",
                                            children: "\uB2E4\uB978 \uC0AC\uC774\uC988\uC5D0\uB3C4 \uC801\uC6A9"
                                        }),
                                        "\uB418\uB2C8 \uCC38\uACE0\uD574 \uC8FC\uC138\uC694."
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(P.ImgGuideWrapper, {
                                    className: "mt-30 mb-30",
                                    children: [
                                        /*#__PURE__*/ _jsx("img", {
                                            src: "/assets/imgs/print/design_guide/\uB514\uC790\uC778 \uC0AC\uC774\uB4DC 1.png"
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "description",
                                            children: [
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "title",
                                                    children: "\uC55E\uBA74 \uC791\uC5C5 \uC601\uC5ED (450mm x 580mm + 40mm)"
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "desc mb-50",
                                                    children: "\uAE30\uBCF8\uC73C\uB85C \uC778\uC1C4\uB418\uC5B4 \uC788\uB294 \uD658\uACBD\uC778\uC99D\uB9C8\uD06C\uC640 \uBB38\uAD6C\uC601\uC5ED\uACFC 40mm\uC601\uC5ED\uC744 \uC81C\uC678\uD55C \uC601\uC5ED\uC5D0 \uC778\uC1C4\uAC00\uB2A5\uD569\uB2C8\uB2E4."
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "title",
                                                    children: "\uB4B7\uBA74 \uC791\uC5C5 \uC601\uC5ED (450mm x 580mm) "
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "desc mb-50",
                                                    children: "40mm \uC601\uC5ED\uC744 \uC81C\uC678\uD55C \uBAA8\uB4E0 \uC601\uC5ED\uC5D0 \uC778\uC1C4\uAC00\uB2A5\uD569\uB2C8\uB2E4."
                                                }),
                                                /*#__PURE__*/ _jsxs("span", {
                                                    className: "danger",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("i", {
                                                            className: "fi-rs-exclamation"
                                                        }),
                                                        "\uC81C\uACF5\uB41C \uCE7C\uC120\uB3C4\uC548\uC740 \uC2E4\uCE21 \uC0AC\uC774\uC988\uB85C \uCE21\uC815\uB3FC\uC788\uC73C\uB2C8 \uC218\uC815\uD558\uC9C0 \uB9D0\uC544\uC8FC\uC138\uC694."
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(P.DesignGuideDownloadWrapper, {
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "ment",
                                            children: "\uB514\uC790\uC778 \uAC00\uC774\uB4DC\uB97C \uB2E4\uC6B4\uB85C\uB4DC\uD558\uC5EC \uB098\uB9CC\uC758 \uB514\uC790\uC778\uC744 \uB9CC\uB4E4\uC5B4 \uBCF4\uC138\uC694."
                                        }),
                                        /*#__PURE__*/ _jsxs("a", {
                                            href: "https://file.caretbio.com/caretbio/\u110F\u1161\u11AF\u1105\u1166\u11BA\u1109\u1173\u1110\u1169\u110B\u1165_\u1109\u1169\u1105\u1163\u11BC\u110B\u1175\u11AB\u1109\u116B_\u110F\u1161\u11AF\u1109\u1165\u11AB\u1100\u1161\u110B\u1175\u1103\u1173_240403153610.Zip",
                                            target: "__blank",
                                            className: "downloadBtn",
                                            children: [
                                                "AI ",
                                                /*#__PURE__*/ _jsx("i", {
                                                    className: "fi-rs-download"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "d-flex flex-column mb-50 pb-80 border-bottom",
                            children: [
                                /*#__PURE__*/ _jsx(P.NumberUnderBarTitle, {
                                    children: "01"
                                }),
                                /*#__PURE__*/ _jsx(P.MediumTitle, {
                                    children: "\uC791\uC5C5\uBB3C \uC724\uACFD\uCC98\uB9AC"
                                }),
                                /*#__PURE__*/ _jsxs(P.ImgGridWrapper, {
                                    length: 2,
                                    children: [
                                        /*#__PURE__*/ _jsxs(P.ImgBox, {
                                            children: [
                                                /*#__PURE__*/ _jsx("img", {
                                                    src: "/assets/imgs/print/design_guide/\uB514\uC790\uC778_\uAC00\uC774\uB4DC_1-1.jpg"
                                                }),
                                                /*#__PURE__*/ _jsxs("span", {
                                                    children: [
                                                        "\uD14D\uC2A4\uD2B8\uB098 \uB3C4\uD615\uC73C\uB85C \uC81C\uC791\uD55C \uC791\uC5C5\uBB3C\uC740",
                                                        " ",
                                                        /*#__PURE__*/ _jsx("strong", {
                                                            children: "Type > Create Outlines [Shift+Ctrl+O]"
                                                        }),
                                                        "\uB97C \uC0AC\uC6A9\uD558\uC5EC \uC724\uACFD\uCC98\uB9AC\uD574 \uC8FC\uC138\uC694."
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs(P.ImgBox, {
                                            children: [
                                                /*#__PURE__*/ _jsx("img", {
                                                    src: "/assets/imgs/print/design_guide/\uB514\uC790\uC778_\uAC00\uC774\uB4DC_1-2.jpg"
                                                }),
                                                /*#__PURE__*/ _jsxs("span", {
                                                    children: [
                                                        "\uD39C\uD234\uC744 \uC0AC\uC6A9\uD55C \uB77C\uC778\uD615\uD0DC\uC758 \uC791\uC5C5\uBB3C\uC740",
                                                        " ",
                                                        /*#__PURE__*/ _jsx("strong", {
                                                            children: "Object > Path > Outline Stroke"
                                                        }),
                                                        "\uC744 \uC0AC\uC6A9\uD558\uC5EC \uC724\uACFD\uCC98\uB9AC\uD574 \uC8FC\uC138\uC694."
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "d-flex flex-column mb-50 pb-80",
                            children: [
                                /*#__PURE__*/ _jsx(P.NumberUnderBarTitle, {
                                    children: "02"
                                }),
                                /*#__PURE__*/ _jsx(P.MediumTitle, {
                                    children: "\uB808\uC774\uC5B4 \uAE30\uB2A5 \uC0AC\uC6A9"
                                }),
                                /*#__PURE__*/ _jsxs(P.ImgGridWrapper, {
                                    length: 2,
                                    children: [
                                        /*#__PURE__*/ _jsxs(P.ImgBox, {
                                            children: [
                                                /*#__PURE__*/ _jsx("img", {
                                                    src: "/assets/imgs/print/design_guide/\uB514\uC790\uC778_\uAC00\uC774\uB4DC_2-1.jpg"
                                                }),
                                                /*#__PURE__*/ _jsxs("span", {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("strong", {
                                                            children: "'\uB514\uC790\uC778'"
                                                        }),
                                                        " \uB808\uC774\uC5B4\uB97C \uC120\uD0DD\uD558\uACE0 \uB514\uC790\uC778\uC774 \uC644\uB8CC\uB41C \uC791\uC5C5\uBB3C\uC744 \uBC30\uCE58\uD574 \uC8FC\uC138\uC694."
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs(P.ImgBox, {
                                            children: [
                                                /*#__PURE__*/ _jsx("img", {
                                                    src: "/assets/imgs/print/design_guide/\uB514\uC790\uC778_\uAC00\uC774\uB4DC_2-2.jpg"
                                                }),
                                                /*#__PURE__*/ _jsxs("span", {
                                                    children: [
                                                        "\uB808\uC774\uC5B4 \uC21C\uC11C\uB294 \uAC00\uC774\uB4DC \uD30C\uC77C \uADF8\uB300\uB85C \uBCC0\uACBD\uC5C6\uC774 \uC791\uC5C5\uD574\uC57C \uD558\uBA70,",
                                                        " ",
                                                        /*#__PURE__*/ _jsx("strong", {
                                                            children: "\uB808\uC774\uC5B4\uBA85 \uBCC0\uACBD \uBC0F \uB808\uC774\uC5B4 \uCD94\uAC00\uB3C4 \uBD88\uAC00"
                                                        }),
                                                        "\uD569\uB2C8\uB2E4."
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            activeMainTab === 2 && /*#__PURE__*/ _jsxs(P.ProductInfoFeature, {
                className: "container",
                id: "feature",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "d-flex flex-column mb-50 pb-80 border-bottom",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "d-flex flex-column mb-50",
                                children: [
                                    /*#__PURE__*/ _jsxs(P.NormalTitle, {
                                        children: [
                                            "\uCE7C\uB81B\uC2A4\uD1A0\uC5B4\uC758",
                                            /*#__PURE__*/ _jsx("strong", {
                                                children: " \uD2B9\uBCC4\uD55C \uC7AC\uC9C8"
                                            }),
                                            "\uC744 \uD655\uC778\uD574 \uBCF4\uC138\uC694."
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx(P.NumberUnderBarTitle, {
                                        children: "01"
                                    }),
                                    /*#__PURE__*/ _jsx(P.MediumTitle, {
                                        children: "EL606 \uD0DD\uBC30\uBD09\uD22C"
                                    }),
                                    /*#__PURE__*/ _jsx(P.TitleDesc, {
                                        children: "\uD0C4\uC18C \uC800\uAC10\uC5D0 \uB3C4\uC6C0\uC744 \uC8FC\uB294 \uC7AC\uC0DD\uBE44\uB2D0 \uCE5C\uD658\uACBD \uD0DD\uBC30\uBD09\uD22C\uC785\uB2C8\uB2E4."
                                    }),
                                    /*#__PURE__*/ _jsxs(P.ImgGridWrapper, {
                                        length: 2,
                                        children: [
                                            /*#__PURE__*/ _jsxs(P.ImgBox, {
                                                children: [
                                                    /*#__PURE__*/ _jsx("img", {
                                                        src: "/assets/imgs/print/info_feature/\uC0C1\uD488\uC18C\uAC1C_\uC7AC\uC9C8_EL606\uD0DD\uBC30\uBD09\uD22C_1.jpg"
                                                    }),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        children: "\uC778\uC7A5\uB825\uACFC \uC0AC\uC774\uB4DC \uC2E4\uB9C1\uC774 \uD2BC\uD2BC\uD558\uC5EC \uB192\uC740 \uB0B4\uAD6C\uC131\uC744 \uBCF4\uC785\uB2C8\uB2E4."
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs(P.ImgBox, {
                                                children: [
                                                    /*#__PURE__*/ _jsx("img", {
                                                        src: "/assets/imgs/print/info_feature/\uC0C1\uD488\uC18C\uAC1C_\uC7AC\uC9C8_EL606\uD0DD\uBC30\uBD09\uD22C_2.jpg"
                                                    }),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        children: "\uD658\uACBD\uD45C\uC9C0 \uC778\uC99D \uBC1B\uC740 \uC7AC\uC0DD\uD50C\uB77C\uC2A4\uD2F1 PCR(EL606) \uC218\uC9C0\uB97C 50% \uC774\uC0C1 \uD65C\uC6A9\uD574, \uD0C4\uC18C\uBC30\uCD9C\uB7C9 \uC800\uAC10\uACFC \uC790\uC6D0\uC120\uC21C\uD658\uC5D0 \uAE30\uC5EC\uD569\uB2C8\uB2E4."
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "d-flex flex-column mb-50",
                                children: [
                                    /*#__PURE__*/ _jsx(P.NormalTitle, {
                                        children: "EL606 \uD0DD\uBC30\uBD09\uD22C \uC0C9\uC0C1\uC744 \uD655\uC778\uD574 \uBCF4\uC138\uC694."
                                    }),
                                    /*#__PURE__*/ _jsxs(P.SmallImgGridWrapper, {
                                        length: 2,
                                        children: [
                                            /*#__PURE__*/ _jsxs(P.SmallImgBox, {
                                                children: [
                                                    /*#__PURE__*/ _jsx("img", {
                                                        src: "/assets/imgs/print/info_feature/\uC0C1\uD488\uC18C\uAC1C_\uC7AC\uC9C8_EL606\uD0DD\uBC30\uBD09\uD22C_\uD551\uD06C.jpg"
                                                    }),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        children: "\uC778\uB514\uD551\uD06C "
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs(P.SmallImgBox, {
                                                children: [
                                                    /*#__PURE__*/ _jsx("img", {
                                                        src: "/assets/imgs/print/info_feature/\uC0C1\uD488\uC18C\uAC1C_\uC7AC\uC9C8_EL606\uD0DD\uBC30\uBD09\uD22C_\uB124\uC628.jpg"
                                                    }),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        children: "\uB124\uC628"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "d-flex flex-column mb-50 pb-80 border-bottom",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "d-flex flex-column mb-50",
                                children: [
                                    /*#__PURE__*/ _jsx(P.NumberUnderBarTitle, {
                                        children: "02"
                                    }),
                                    /*#__PURE__*/ _jsx(P.MediumTitle, {
                                        children: "EL727 \uD0DD\uBC30\uBD09\uD22C"
                                    }),
                                    /*#__PURE__*/ _jsx(P.TitleDesc, {
                                        children: "\uD0C4\uC18C \uC800\uAC10\uC5D0 \uB3C4\uC6C0\uC744 \uC8FC\uB294 \uBC14\uC774\uC624\uB9E4\uC2A4 \uD0DD\uBC30\uBD09\uD22C\uC785\uB2C8\uB2E4."
                                    }),
                                    /*#__PURE__*/ _jsxs(P.ImgGridWrapper, {
                                        length: 2,
                                        children: [
                                            /*#__PURE__*/ _jsxs(P.ImgBox, {
                                                children: [
                                                    /*#__PURE__*/ _jsx("img", {
                                                        src: "/assets/imgs/print/info_feature/\uC0C1\uD488\uC18C\uAC1C_\uC7AC\uC9C8_EL727\uD0DD\uBC30\uBD09\uD22C_1.jpg"
                                                    }),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        children: "\uB0B4\uAD6C\uC131\uC774 \uC6B0\uC218\uD558\uACE0 \uC774\uC911\uD569\uC9C0\uB85C \uC9C8\uAE30\uACE0 \uD2BC\uD2BC\uD558\uAC8C \uC81C\uC791\uB418\uC5C8\uC2B5\uB2C8\uB2E4."
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs(P.ImgBox, {
                                                children: [
                                                    /*#__PURE__*/ _jsx("img", {
                                                        src: "/assets/imgs/print/info_feature/\uC0C1\uD488\uC18C\uAC1C_\uC7AC\uC9C8_EL727\uD0DD\uBC30\uBD09\uD22C_2.jpg"
                                                    }),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        children: "\uBC14\uC774\uC624\uB9E4\uC2A4 \uC18C\uC7AC \uC778\uC99D\uC744 \uBC1B\uC544 \uD0C4\uC18C\uC800\uAC10\uC5D0 \uD6A8\uACFC\uAC00 \uC788\uC2B5\uB2C8\uB2E4."
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "d-flex flex-column mb-50",
                                children: [
                                    /*#__PURE__*/ _jsx(P.NormalTitle, {
                                        children: "EL727 \uD0DD\uBC30\uBD09\uD22C \uC0C9\uC0C1\uC744 \uD655\uC778\uD574 \uBCF4\uC138\uC694."
                                    }),
                                    /*#__PURE__*/ _jsxs(P.SmallImgGridWrapper, {
                                        length: 2,
                                        children: [
                                            /*#__PURE__*/ _jsxs(P.SmallImgBox, {
                                                children: [
                                                    /*#__PURE__*/ _jsx("img", {
                                                        src: "/assets/imgs/print/info_feature/\uC0C1\uD488\uC18C\uAC1C_\uC7AC\uC9C8_EL727\uD0DD\uBC30\uBD09\uD22C_\uD06C\uB9BC.jpg"
                                                    }),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        children: "\uD06C\uB9BC"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs(P.SmallImgBox, {
                                                children: [
                                                    /*#__PURE__*/ _jsx("img", {
                                                        src: "/assets/imgs/print/info_feature/\uC0C1\uD488\uC18C\uAC1C_\uC7AC\uC9C8_EL727\uD0DD\uBC30\uBD09\uD22C_\uBE14\uB799.jpg"
                                                    }),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        children: "\uBE14\uB799"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "d-flex flex-column mb-0 pb-80",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "d-flex flex-column mb-50",
                                children: [
                                    /*#__PURE__*/ _jsx(P.NumberUnderBarTitle, {
                                        children: "03"
                                    }),
                                    /*#__PURE__*/ _jsx(P.MediumTitle, {
                                        children: "EL727 \uC18D\uBE44\uB2D0\uBD09\uD22C"
                                    }),
                                    /*#__PURE__*/ _jsx(P.TitleDesc, {
                                        children: "\uD0C4\uC18C \uC800\uAC10\uC5D0 \uB3C4\uC6C0\uC744 \uC8FC\uB294 \uCE5C\uD658\uACBD \uBC14\uC774\uC624\uB9E4\uC2A4 \uC18D\uBE44\uB2D0\uBD09\uD22C\uC785\uB2C8\uB2E4."
                                    }),
                                    /*#__PURE__*/ _jsxs(P.ImgGridWrapper, {
                                        length: 2,
                                        children: [
                                            /*#__PURE__*/ _jsxs(P.ImgBox, {
                                                children: [
                                                    /*#__PURE__*/ _jsx("img", {
                                                        src: "/assets/imgs/print/info_feature/\uC0C1\uD488\uC18C\uAC1C_\uC7AC\uC9C8_EL727\uC18D\uBE44\uB2D0\uBD09\uD22C_1.jpg"
                                                    }),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        children: "\uB0B4\uAD6C\uC131\uC774 \uC6B0\uC218\uD558\uACE0 \uC774\uC911\uD569\uC9C0\uB85C \uC9C8\uAE30\uACE0 \uD2BC\uD2BC\uD558\uAC8C \uC81C\uC791\uB418\uC5C8\uC2B5\uB2C8\uB2E4."
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs(P.ImgBox, {
                                                children: [
                                                    /*#__PURE__*/ _jsx("img", {
                                                        src: "/assets/imgs/print/info_feature/\uC0C1\uD488\uC18C\uAC1C_\uC7AC\uC9C8_EL727\uC18D\uBE44\uB2D0\uBD09\uD22C_2.jpg"
                                                    }),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        children: "\uBC14\uC774\uC624\uB9E4\uC2A4 \uC18C\uC7AC \uC778\uC99D\uC744 \uBC1B\uC544 \uD0C4\uC18C\uC800\uAC10\uC5D0 \uD6A8\uACFC\uAC00 \uC788\uC2B5\uB2C8\uB2E4."
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "d-flex flex-column mb-50",
                                children: [
                                    /*#__PURE__*/ _jsx(P.NormalTitle, {
                                        children: "EL727 \uC18D\uBE44\uB2D0\uBD09\uD22C \uC0C9\uC0C1\uC744 \uD655\uC778\uD574 \uBCF4\uC138\uC694."
                                    }),
                                    /*#__PURE__*/ _jsx(P.SmallImgGridWrapper, {
                                        length: 1,
                                        children: /*#__PURE__*/ _jsxs(P.SmallImgBox, {
                                            children: [
                                                /*#__PURE__*/ _jsx("img", {
                                                    src: "/assets/imgs/print/info_feature/\uC0C1\uD488\uC18C\uAC1C_\uC7AC\uC9C8_EL727\uC18D\uBE44\uB2D0\uBD09\uD22C_\uBC18\uD22C\uBA85.jpg"
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    children: "\uBC18\uD22C\uBA85 "
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            activeMainTab === 3 && /*#__PURE__*/ _jsxs(P.ProductInfoSize, {
                className: "container",
                id: "size",
                ref: observers[1].ref,
                children: [
                    /*#__PURE__*/ _jsxs(P.NormalTitle, {
                        children: [
                            /*#__PURE__*/ _jsx("strong", {
                                children: "\uD544\uC694\uD558\uC2E0 \uC0AC\uC774\uC988"
                            }),
                            "\uC5D0 \uB9DE\uAC8C \uC120\uD0DD\uD558\uC138\uC694."
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(P.SizeTabWrapper, {
                        children: [
                            Object.keys(SizeData).map(function(el, i) {
                                return /*#__PURE__*/ _jsx(P.SizeTab, {
                                    active: i === activeTab,
                                    onClick: function() {
                                        return setActiveTab(i);
                                    },
                                    children: el
                                }, i);
                            }),
                            /*#__PURE__*/ _jsx(P.SizeSelect, {
                                children: /*#__PURE__*/ _jsx("select", {
                                    className: "form-select",
                                    value: activeTab,
                                    onChange: function(e) {
                                        return setActiveTab(e.target.value);
                                    },
                                    children: Object.keys(SizeData).map(function(el, i) {
                                        return /*#__PURE__*/ _jsx("option", {
                                            value: i,
                                            children: el
                                        }, i);
                                    })
                                })
                            })
                        ]
                    }),
                    Object.values(SizeData)[activeTab].map(function(el, i) {
                        return /*#__PURE__*/ _jsxs(P.ProductSizeBox, {
                            children: [
                                /*#__PURE__*/ _jsx(P.BoldSmallTitle, {
                                    children: el.title
                                }),
                                /*#__PURE__*/ _jsx(P.NormalTitle, {
                                    children: el.size
                                }),
                                /*#__PURE__*/ _jsx(P.TitleDesc, {
                                    children: el.desc
                                }),
                                /*#__PURE__*/ _jsx(P.ImgGridWrapper, {
                                    length: el.imgs.length,
                                    children: el.imgs.map(function(img, imgIdx) {
                                        return /*#__PURE__*/ _jsxs(P.ImgBox, {
                                            children: [
                                                /*#__PURE__*/ _jsx("img", {
                                                    src: img.url
                                                }),
                                                img.desc && /*#__PURE__*/ _jsx("span", {
                                                    children: img.desc
                                                })
                                            ]
                                        }, imgIdx);
                                    })
                                })
                            ]
                        }, i);
                    })
                ]
            }),
            activeMainTab === 4 && /*#__PURE__*/ _jsx(P.DesignGuide, {
                className: "",
                id: "essential",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "container mb-50",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "d-flex flex-column",
                        children: [
                            /*#__PURE__*/ _jsxs(P.NormalTitle, {
                                children: [
                                    /*#__PURE__*/ _jsx("strong", {
                                        children: "\uB514\uC790\uC778 \uC81C\uC791\uC694\uCCAD \uC0AC\uD56D"
                                    }),
                                    " \uD544\uC218\uAE30\uC7AC!"
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(P.ImgGridWrapper, {
                                length: 2,
                                children: [
                                    /*#__PURE__*/ _jsxs(P.ImgBox, {
                                        children: [
                                            /*#__PURE__*/ _jsx("img", {
                                                src: "/assets/imgs/print/design_essential/\uB514\uC790\uC778_\uD544\uC218\uC0AC\uD56D1.jpg"
                                            }),
                                            /*#__PURE__*/ _jsxs("span", {
                                                children: [
                                                    "\uD654\uC774\uD2B8 / \uBE14\uB799 \uC774\uC678\uC5D0 \uCEEC\uB7EC\uB294 ",
                                                    /*#__PURE__*/ _jsx("strong", {
                                                        children: "\uD32C\uD1A4\uCEEC\uB7EC\uB97C \uAE30\uC7AC"
                                                    }),
                                                    "\uD574 \uC8FC\uC138\uC694."
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs(P.ImgBox, {
                                        children: [
                                            /*#__PURE__*/ _jsx("img", {
                                                src: "/assets/imgs/print/design_essential/\uB514\uC790\uC778_\uD544\uC218\uC0AC\uD56D2.jpg"
                                            }),
                                            /*#__PURE__*/ _jsxs("span", {
                                                children: [
                                                    "\uD0DD\uBC30\uBD09\uD22C\uC758 \uBC11\uB2E8\uBD80\uD130 \uC791\uC5C5\uD558\uC2E0 \uC791\uC5C5\uBB3C \uBC11\uB2E8\uAE4C\uC9C0",
                                                    " ",
                                                    /*#__PURE__*/ _jsx("strong", {
                                                        children: "mm\uB85C \uCE21\uC815\uD558\uC5EC \uAE30\uC7AC"
                                                    }),
                                                    "\uD574 \uC8FC\uC138\uC694."
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            shouldShowTabContent(5) && /*#__PURE__*/ _jsxs("div", {
                className: "container mb-50",
                children: [
                    /*#__PURE__*/ _jsxs(P.NormalTitle, {
                        children: [
                            "\uC18C\uB7C9\uC778\uC1C4 ",
                            /*#__PURE__*/ _jsx("strong", {
                                children: "FAQ"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Faq.TableWrapper, {
                        children: faqList.map(function(el, i) {
                            return /*#__PURE__*/ _jsxs(Faq.TableRow, {
                                onClick: onClickOpenFAQ(i),
                                children: [
                                    /*#__PURE__*/ _jsxs(Faq.FAQTop, {
                                        isActive: isActive === i,
                                        children: [
                                            /*#__PURE__*/ _jsxs(Faq.FAQTitle, {
                                                children: [
                                                    el.category,
                                                    el.title
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx("i", {
                                                className: isActive === i ? "fi-rs-angle-small-up" : "fi-rs-angle-small-down"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx(Faq.FAQContent, {
                                        isActive: isActive === i,
                                        dangerouslySetInnerHTML: {
                                            __html: el.contents
                                        }
                                    })
                                ]
                            }, i);
                        })
                    })
                ]
            }),
            shouldShowTabContent(6) && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsxs(P.NormalTitle, {
                        children: [
                            /*#__PURE__*/ _jsx("strong", {
                                children: "\uC0C1\uD488 \uBC0F \uACAC\uC801"
                            }),
                            "\uC744 \uD55C \uBC88\uC5D0 \uC9C4\uD589\uD558\uC138\uC694."
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "container",
                        ref: listRef,
                        children: /*#__PURE__*/ _jsx(FilterList, {
                            productList: productList,
                            addCart: addPrintCart,
                            inCart: inCart
                        })
                    }),
                    (userInfo === null || userInfo === void 0 ? void 0 : (ref = userInfo.Member) === null || ref === void 0 ? void 0 : ref.ukey) ? /*#__PURE__*/ _jsx("div", {
                        className: "container",
                        ref: cartRef,
                        children: /*#__PURE__*/ _jsx(PrintCart, {
                            userInfo: userInfo,
                            userCompany: userCompany,
                            printCartItems: printCartItems,
                            setPrintCartItems: setPrintCartItems,
                            moveToList: moveToList
                        })
                    }) : /*#__PURE__*/ _jsx("div", {
                        className: "container",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "d-flex justify-content-center align-items-center pt-50 pb-50",
                            children: /*#__PURE__*/ _jsxs("h6", {
                                children: [
                                    /*#__PURE__*/ _jsx("a", {
                                        href: "/login",
                                        children: "\uB85C\uADF8\uC778"
                                    }),
                                    " \uD6C4 \uC774\uC6A9\uAC00\uB2A5\uD55C \uC11C\uBE44\uC2A4 \uC785\uB2C8\uB2E4."
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(P.DesignBanner, {
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "content container-lg",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "textContent",
                            children: [
                                /*#__PURE__*/ _jsx("span", {
                                    children: "\uB85C\uACE0\uAC00 \uC5C6\uB2E4\uBA74?"
                                }),
                                /*#__PURE__*/ _jsx("h6", {
                                    children: "\uCE7C\uB81B\uC2A4\uD1A0\uC5B4 \uB514\uC790\uC778 \uC11C\uBE44\uC2A4\uB97C \uC774\uC6A9\uD574\uBCF4\uC138\uC694"
                                }),
                                /*#__PURE__*/ _jsxs("span", {
                                    children: [
                                        "\uAC04\uB2E8\uD55C \uB85C\uACE0 \uBC30\uCE58\uBD80\uD130 \uBE0C\uB79C\uB4DC \uB514\uC790\uC778\uAE4C\uC9C0! ",
                                        /*#__PURE__*/ _jsx("br", {}),
                                        " \uAC00\uACA9\uBCC4\uB85C \uB098\uC5D0\uAC8C \uB9DE\uB294 \uB514\uC790\uC778 \uC11C\uBE44\uC2A4\uB97C \uC774\uC6A9\uD574\uBCF4\uC138\uC694"
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("img", {
                                    src: "https://file.caretbio.com/caretbio/9ac7d2c8185a56a72ecf459b2021022a.png",
                                    className: "m_banner"
                                }),
                                /*#__PURE__*/ _jsx("a", {
                                    className: "",
                                    href: "/customizing/design-service/",
                                    children: "\uC11C\uBE44\uC2A4 \uBCF4\uB7EC\uAC00\uAE30"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("img", {
                            src: "https://file.caretbio.com/caretbio/47ffdb3584f54f4251b1c79b3aad90c1.png",
                            className: "pc_banner"
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var Print_presenter = ((/* unused pure expression or super */ null && (PrintPageUI)));
var defaultTabs = [
    {
        label: "\uC0C1\uD488\uC18C\uAC1C"
    },
    {
        label: "\uAC00\uC774\uB4DC"
    },
    {
        label: "\uC7AC\uC9C8"
    },
    {
        label: "\uC0AC\uC774\uC988"
    },
    {
        label: "\uD544\uC218\uC0AC\uD56D"
    },
    {
        label: "FAQ"
    },
    {
        label: "\uC0C1\uD488 \u2022 \uACAC\uC801"
    }, 
];

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./common/auth.js + 4 modules
var auth = __webpack_require__(48106);
// EXTERNAL MODULE: ./common/splicePrice.js
var splicePrice = __webpack_require__(8025);
// EXTERNAL MODULE: ./redux/action/confirm.js
var action_confirm = __webpack_require__(94184);
;// CONCATENATED MODULE: ./components/customizing/print/Print.ProductsList.js
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}












var PrintProductsList = function(param) {
    var productList = param.productList, printCartItems = param.printCartItems, dummyList = param.dummyList, listModal = param.listModal, handleListModal = param.handleListModal, _$closeConfirmModal = param.closeConfirmModal, _$modifyConfirmModal = param.modifyConfirmModal, _$openConfirmModal = param.openConfirmModal, addPrintCart = param.addPrintCart;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)([]), confirmItems = ref[0], setConfirmItems = ref[1];
    var ref1 = (0,react.useState)([]), selectedItem = ref1[0], setSelectedItem = ref1[1];
    // 상품 체크
    var selectItem = function(e, el, i) {
        var tempArr = _toConsumableArray(selectedItem);
        tempArr[i] = e.target.checked;
        setSelectedItem(tempArr);
        if (e.target.checked) {
            var tempArr2 = [
                el
            ].concat(_toConsumableArray(confirmItems));
            setConfirmItems(tempArr2);
        } else {
            var tempArr21 = _toConsumableArray(confirmItems);
            var index = tempArr21.findIndex(function(product) {
                return product.pcode === el.pcode;
            });
            tempArr21.splice(index, 1);
            setConfirmItems(tempArr21);
        }
    };
    // 전체 선택
    var selectAllItems = function(e) {
        if (e.target.checked) {
            var tempArr = new Array(productList.length).fill(true);
            setSelectedItem(tempArr);
            setConfirmItems(productList);
        } else {
            var tempArr2 = new Array(productList.length).fill(false);
            setSelectedItem(tempArr2);
            setConfirmItems([]);
        }
    };
    // 전체삭제
    var deleteAll = function() {
        var content = {
            title: "\uC804\uBD80 \uC0AD\uC81C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
            actionBtnLabel: "\uD655\uC778",
            actionBtnValid: true,
            cancelBtnLabel: "\uCDE8\uC18C",
            onAction: function() {
                setConfirmItems([]);
                setSelectedItem([]);
                successAlert("\uC7A5\uBC14\uAD6C\uB2C8 \uC804\uCCB4 \uC0AD\uC81C \uC644\uB8CC");
                _$closeConfirmModal();
            }
        };
        _$modifyConfirmModal(content);
        _$openConfirmModal();
    };
    (0,react.useEffect)(function() {
        if (!listModal) return;
        var tempArr2 = new Array(productList.length).fill(false);
        setSelectedItem(tempArr2);
    }, [
        productList,
        listModal
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Print_styles/* TableTypeWrapper */.ze, {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Print_styles/* Table */.iA, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                className: "header",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("th", {
                                        className: "custome-checkbox",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                type: "checkbox",
                                                className: "form-check-input",
                                                id: "all",
                                                onChange: function(e) {
                                                    return selectAllItems(e);
                                                },
                                                checked: !selectedItem.includes(false)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                htmlFor: "all",
                                                className: "form-check-label"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        className: "img",
                                        children: "\uC774\uBBF8\uC9C0"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        className: "name",
                                        children: "\uD488\uBA85"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        className: "sizes",
                                        children: "\uC0AC\uC774\uC988"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        className: "onePrice",
                                        children: "\uB2E8\uAC00"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        className: "quantity",
                                        children: "\uBB36\uC74C \uC218\uB7C9"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        children: "\uD310\uB9E4\uAC00"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        children: "\uC778\uC1C4 \uBE44\uC6A9"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                        children: "\uC608\uC0C1 \uD569 \uAC00\uACA9"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                            children: productList && productList.length > 0 && productList.map(function(product, i) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                            className: "custome-checkbox",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "checkbox",
                                                    className: "form-check-input",
                                                    id: product.pcode,
                                                    onChange: function(e) {
                                                        return selectItem(e, product, i);
                                                    },
                                                    checked: selectedItem[i]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                    className: "form-check-label",
                                                    style: {
                                                        textTransform: "capitalize"
                                                    },
                                                    htmlFor: product.pcode
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            className: "img",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/products/".concat(product.ename, "/").concat(product.pcode, "/"),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: product.main_image,
                                                        alt: product.pname
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            className: "name",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/products/".concat(product.ename, "/").concat(product.pcode, "/"),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    children: product.pname
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            className: "sizes",
                                            children: (product.horizontal != 0 ? product.horizontal : "-") + (product.vertical != 0 ? "X" + product.vertical : "") + (product.height != 0 ? "X" + product.height : "")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                            className: "onePrice",
                                            children: [
                                                (0,splicePrice/* priceComma */.a)(Math.round(Number(product.discount_price) / Number(product.quantity))),
                                                "\uC6D0"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                            className: "quantity",
                                            children: [
                                                (0,splicePrice/* priceComma */.a)(product.quantity),
                                                "\uAC1C"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            className: "price",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Print_styles/* PriceBox */.bz, {
                                                children: [
                                                    product.salePer > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: product.price && " ".concat((0,splicePrice/* priceComma */.a)(product.price), "\uC6D0")
                                                        })
                                                    }),
                                                    (0,splicePrice/* priceComma */.a)(product.discount_price),
                                                    "\uC6D0"
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                            className: "print_price",
                                            children: [
                                                (0,splicePrice/* priceComma */.a)(Number(product.small_price) * Number(product.quantity)),
                                                "\uC6D0"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                            className: "total_price",
                                            children: [
                                                (0,splicePrice/* priceComma */.a)(Number(product.discount_price) + Number(product.small_price) * Number(product.quantity)),
                                                "\uC6D0"
                                            ]
                                        })
                                    ]
                                }, i);
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Print_styles/* BtnWrapper */.Bo, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: "btn",
                    onClick: function() {
                        setConfirmItems([]);
                        setSelectedItem([]);
                        addPrintCart(confirmItems);
                    },
                    children: "\uC120\uD0DD \uACAC\uC801 \uB2F4\uAE30"
                })
            })
        ]
    });
};
var mapStateToProps = function(state) {
    return {};
};
var mapDispatchToProps = {
    closeConfirmModal: action_confirm/* closeConfirmModal */.d6,
    modifyConfirmModal: action_confirm/* modifyConfirmModal */.sR,
    openConfirmModal: action_confirm/* openConfirmModal */._5
};
/* harmony default export */ var Print_ProductsList = ((0,es/* connect */.$j)(mapStateToProps, mapDispatchToProps)(PrintProductsList));

// EXTERNAL MODULE: ./api/smallPackaging.js
var smallPackaging = __webpack_require__(85134);
// EXTERNAL MODULE: ./api/getUserInfo.js + 1 modules
var getUserInfo = __webpack_require__(48934);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
// EXTERNAL MODULE: ./utils/seo/SeoMeta.js
var SeoMeta = __webpack_require__(44027);
// EXTERNAL MODULE: ./components/customizing/print/PrintDesignService.js
var PrintDesignService = __webpack_require__(52658);
// EXTERNAL MODULE: ./components/customizing/print/printTab/PrintTab.jsx
var PrintTab = __webpack_require__(48071);
;// CONCATENATED MODULE: ./pages/customizing/print/index.js
function print_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function print_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return print_arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function print_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function print_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function print_toConsumableArray(arr) {
    return print_arrayWithoutHoles(arr) || print_iterableToArray(arr) || print_unsupportedIterableToArray(arr) || print_nonIterableSpread();
}
function print_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return print_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return print_arrayLikeToArray(o, minLen);
}

























var CustomizingPrintPage = function(param) {
    var _$isLoaded = param.isLoaded, _$isLoading = param.isLoading, _$closeConfirmModal = param.closeConfirmModal, _$modifyConfirmModal = param.modifyConfirmModal, _$openConfirmModal = param.openConfirmModal, userInfo = param.userInfo;
    var router = (0,next_router.useRouter)();
    var ref7 = (0,react.useState)({}), inquiryInputs = ref7[0], setInquiryInputs = ref7[1];
    var ref1 = (0,react.useState)(false), openInquiryModal = ref1[0], setOpenInquiryModal = ref1[1];
    var ref2 = (0,react.useState)(false), openInquiryComplete = ref2[0], setOpenInquiryComplete = ref2[1];
    var ref3 = (0,react.useState)([]), productList = ref3[0], setProductList = ref3[1];
    var ref4 = (0,react.useState)([]), printCartItems = ref4[0], setPrintCartItems = ref4[1];
    var cartRef = (0,react.useRef)(null);
    var listRef = (0,react.useRef)(null);
    var userCompany = (0,react.useMemo)(function() {
        var ref, ref5;
        if (userInfo === null || userInfo === void 0 ? void 0 : (ref = userInfo.Company) === null || ref === void 0 ? void 0 : (ref5 = ref.Data) === null || ref5 === void 0 ? void 0 : ref5.code) {
            var ref6;
            return userInfo === null || userInfo === void 0 ? void 0 : (ref6 = userInfo.Company) === null || ref6 === void 0 ? void 0 : ref6.Data;
        } else {
            return null;
        }
    }, [
        userInfo
    ]);
    var onClickInquiry = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setOpenInquiryModal(function(prev) {
                            return !prev;
                        });
                        setInquiryInputs({});
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onClickInquiry() {
            return _ref.apply(this, arguments);
        };
    }();
    var onChangeInquiry = function(e, id) {
        if (id.includes("file")) {
            setInquiryInputs(_objectSpread({}, inquiryInputs, _defineProperty({}, id, e.target.files[0])));
            return;
        }
        if (id === "policy") {
            setInquiryInputs(_objectSpread({}, inquiryInputs, _defineProperty({}, id, e.target.checked)));
            return;
        }
        setInquiryInputs(_objectSpread({}, inquiryInputs, _defineProperty({}, id, e.target.value)));
    };
    var onClickInquiryComplete = function() {
        setOpenInquiryComplete(function(prev) {
            return !prev;
        });
    };
    var submitInquiry = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
            var body, res, ref;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(!inquiryInputs.name || !inquiryInputs.tel || !inquiryInputs.cnt || !inquiryInputs.usages || !inquiryInputs.email || !inquiryInputs.content)) {
                            _ctx.next = 3;
                            break;
                        }
                        (0,common_alert/* failAlert */.qh)("\uD56D\uBAA9\uC744 \uC804\uBD80 \uC785\uB825\uD574\uC8FC\uC138\uC694.");
                        return _ctx.abrupt("return");
                    case 3:
                        if (inquiryInputs.policy) {
                            _ctx.next = 6;
                            break;
                        }
                        (0,common_alert/* failAlert */.qh)("\uC720\uC758\uC0AC\uD56D\uC5D0 \uB3D9\uC758\uD574\uC8FC\uC138\uC694.");
                        return _ctx.abrupt("return");
                    case 6:
                        if (inquiryInputs.tel.match(/^(0[2-8][0-5]?|01[01346-9])-?([1-9]{1}[0-9]{2,3})-?([0-9]{4})$/)) {
                            _ctx.next = 9;
                            break;
                        }
                        (0,common_alert/* failAlert */.qh)("\uC0AC\uC6A9\uAC00\uB2A5\uD55C \uC804\uD654\uBC88\uD638\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694.");
                        return _ctx.abrupt("return");
                    case 9:
                        _$isLoading();
                        body = _objectSpread({
                            modes: "InquirySet",
                            division: "F",
                            pcode: "P000001"
                        }, inquiryInputs);
                        _ctx.next = 13;
                        return (0,products/* inquirySet */.Bg)(body);
                    case 13:
                        res = _ctx.sent;
                        if (res.Code === "0000") {
                            ;
                            (0,common_alert/* successAlert */.Cq)(((ref = res.Data) === null || ref === void 0 ? void 0 : ref.Msg) || "\uBB38\uC758\uAC00 \uB4F1\uB85D\uB418\uC5C8\uC2B5\uB2C8\uB2E4.");
                            onClickInquiryComplete();
                            onClickInquiry();
                            setInquiryInputs({});
                            _$isLoaded();
                        } else {
                            (0,common_alert/* failAlert */.qh)("\uBB38\uC758 \uB4F1\uB85D\uC5D0 \uC2E4\uD328\uD588\uC2B5\uB2C8\uB2E4.");
                            _$isLoaded();
                        }
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function submitInquiry() {
            return _ref.apply(this, arguments);
        };
    }();
    // 소량 인쇄 상품 리스트
    var fetchProducts = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
            var body, res, ref;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        body = {
                            modes: "ProductsListSet"
                        };
                        _ctx.next = 3;
                        return (0,smallPackaging/* smallPackagingAPI */.t)(body);
                    case 3:
                        res = _ctx.sent;
                        if (res.Code === "0000") {
                            ;
                            setProductList((ref = res.Data) === null || ref === void 0 ? void 0 : ref.rows.data);
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function fetchProducts() {
            return _ref.apply(this, arguments);
        };
    }();
    // 견적 카트 상품 불러오기
    var fetchPrintCartItems = function() {
        var items = JSON.parse(sessionStorage.getItem("printCart"));
        if (items && items.length > 0) {
            setPrintCartItems(items);
        }
    };
    // 카트 담기
    var addPrintCart = function(product) {
        var ref;
        if (!(userInfo === null || userInfo === void 0 ? void 0 : (ref = userInfo.Member) === null || ref === void 0 ? void 0 : ref.ukey)) {
            (0,common_alert/* failAlert */.qh)("\uB85C\uADF8\uC778 \uD6C4 \uC774\uC6A9 \uAC00\uB2A5\uD569\uB2C8\uB2E4.");
            router.push("/login");
            return;
        }
        if (printCartItems.find(function(el) {
            return el.pcode === product.pcode;
        })) {
            (0,common_alert/* failAlert */.qh)("\uC774\uBBF8 \uB2F4\uAE34 \uC0C1\uD488\uC785\uB2C8\uB2E4.");
            return;
        }
        (0,common_alert/* successAlert */.Cq)("\uC7A5\uBC14\uAD6C\uB2C8\uC5D0 \uB2F4\uACBC\uC2B5\uB2C8\uB2E4.");
        var tempArr = [
            _objectSpread({}, product, {
                cnt: 1
            })
        ].concat(print_toConsumableArray(printCartItems));
        setPrintCartItems(tempArr);
        sessionStorage.setItem("printCart", JSON.stringify(tempArr));
        window.scrollTo({
            behavior: "smooth",
            left: 0,
            top: cartRef.current.offsetTop
        });
    };
    // 카트 담긴 상태
    var inCart = function(product) {
        var ref;
        if (!(userInfo === null || userInfo === void 0 ? void 0 : (ref = userInfo.Member) === null || ref === void 0 ? void 0 : ref.ukey)) {
            return false;
        }
        return printCartItems.find(function(el) {
            return el.pcode === product.pcode;
        }) ? true : false;
    };
    (0,react.useEffect)(function() {
        fetchProducts();
        fetchPrintCartItems();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
            parent: "\uD648",
            sub: "\uC18C\uB7C9\uC778\uC1C4",
            pageTitle: SeoMeta/* SeoMeta.smallPrintService.title */.e.smallPrintService.title,
            pageDesc: SeoMeta/* SeoMeta.smallPrintService.description */.e.smallPrintService.description,
            pageKeyword: SeoMeta/* SeoMeta.smallPrintService.keywords */.e.smallPrintService.keywords,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PrintTab/* PrintTab */.d, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Print_styles/* NormalTitle */.XG, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: "\uC18C\uB7C9\uC778\uC1C4"
                                }),
                                " \uC11C\uBE44\uC2A4 \uC18C\uAC1C"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Print_styles/* StrengthWarpper */.nT, {
                            children: Print_data/* strengthArr.map */.AA.map(function(st, idx) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Print_styles/* StrengthBox */.X3, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: st.img,
                                            alt: st.img
                                        }),
                                        st.desc.map(function(el, i) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: el
                                            }, i);
                                        })
                                    ]
                                }, idx);
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Print_styles/* StrengthSliderWrapper */.vw, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "strengthSection",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Print_styles/* StrengthPC */.lz, {
                                className: "container",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h6", {
                                        children: [
                                            "\uCE7C\uB81B\uC2A4\uD1A0\uC5B4\uC758 ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                children: "\uC18C\uB7C9\uC778\uC1C4"
                                            }),
                                            "\uAC00 \uD2B9\uBCC4\uD55C \uC774\uC720!"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "strengthGrid",
                                        children: Print_data/* strengthSlideArr.map */.vW.map(function(str, idx) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "content",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: str.img
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "desc",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                                children: str.title
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: str.desc
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }, idx);
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "container swiperSection",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                                    navigation: {
                                        prevEl: ".custom_prev_i1",
                                        nextEl: ".custom_next_i1"
                                    },
                                    pagination: {
                                        clickable: true,
                                        el: ".swiper-pagination"
                                    },
                                    children: Print_data/* strengthSlideArr.map */.vW.map(function(str, idx) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Print_styles/* StrengthSlide */.AZ, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h6", {
                                                        children: [
                                                            "\uCE7C\uB81B\uC2A4\uD1A0\uC5B4\uC758 ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                children: "\uC18C\uB7C9\uC778\uC1C4"
                                                            }),
                                                            "\uAC00 \uD2B9\uBCC4\uD55C \uC774\uC720!"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "content",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                src: str.img
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "desc",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                                        children: str.title
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        children: str.desc
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }, idx);
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "slider-arrow",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "slider-btn slider-prev slick-arrow custom_prev_i1",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                className: "fi-rs-angle-left"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "slider-btn slider-next slick-arrow custom_next_i1",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                className: "fi-rs-angle-right"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "swiper-pagination"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PrintDesignService/* PrintDesignService */.$, {})
            ]
        })
    });
};
var print_mapStateToProps = function(state) {
    return {
        userInfo: state.userInfo
    };
};
var print_mapDispatchToProps = {
    isLoading: loading/* isLoading */.h,
    isLoaded: loading/* isLoaded */.k,
    closeConfirmModal: action_confirm/* closeConfirmModal */.d6,
    modifyConfirmModal: action_confirm/* modifyConfirmModal */.sR,
    openConfirmModal: action_confirm/* openConfirmModal */._5
};
/* harmony default export */ var print = ((0,es/* connect */.$j)(print_mapStateToProps, print_mapDispatchToProps)(CustomizingPrintPage));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,9199,4231,2511,4027,783,4948,1111,5830,4238,9774,2888,179], function() { return __webpack_exec__(22636); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);